import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    locale: localStorage.getItem("locale")
  },
  mutations: {
    setLocale(state, locale) {
      state.locale = locale;
      localStorage.setItem("locale", locale);
    }
  },
  getters: {
    locale: state => {
      return state.locale;
    }
  },
  actions: {
    setLocale({ commit }, locale) {
      commit("setLocale", locale);
    }
  }
});

export default store;
